import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import AcompanhamentoCargaFOBCompleteParameters from "../classes/AcompanhamentoCargaFOBCompleteParameters";
import AcompanhamentoCargaFOBParameters from "../classes/AcompanhamentoCargaFOBParameters";
import AcompanhamentoEntregaFOB from "../classes/AcompanhamentoEntregaFOB";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  {
    method: "GET",
    rota: "AcompanhamentoCargaFOB/All/RecuperarPorFiltro",
  },
  { method: "POST", rota: "AcompanhamentoCargaFOB/Adicionar" },
  { method: "PUT", rota: "AcompanhamentoCargaFOB/AtualizarLote" },
  { method: "DELETE", rota: "AcompanhamentoCargaFOB/Apagar" },
];

const cacheKey: string = "AcompanhamentoCargaFOBCache";
const cacheKeySelC: string = "AcompanhamentoCargaFOBSelecionado";

const apiServico: string = "PEDIDOS";

export default class AcompanhamentoEntregaFOBDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(param : AcompanhamentoCargaFOBParameters): Promise<AcompanhamentoEntregaFOB[]> {
    return super.post(calls[0].rota, param)
    .then((result) => {
      return result;
    });    
  }

  /*
  async getAll(idFornecedor: number, skus: string[], contratos: string[], numeroPedido: string, numeroItem: string): Promise<AcompanhamentoEntregaFOB[]> {
    let ok: boolean = false;
    let data: AcompanhamentoEntregaFOB[] = [];
    let error: any = undefined;
    let url: string = `${calls[0].rota}?IdFornecedor=${idFornecedor}&pedido=${numeroPedido}&item=${numeroItem}`

    skus.forEach(sku=> url += `&sku=${sku}`);
    contratos.forEach(contrato=> url += `&contrato=${contrato}`);

    await super
      .Get(url)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = AcompanhamentoEntregaFOB.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<AcompanhamentoEntregaFOB[]>((resolve) => {
      resolve(data);
    });
  }
*/
  async add(value: AcompanhamentoEntregaFOB) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[1].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async update(value: AcompanhamentoEntregaFOB): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .put(calls[2].rota, AcompanhamentoEntregaFOB.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  async remove(value: AcompanhamentoEntregaFOB): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    await super
      .delete(calls[3].rota, AcompanhamentoEntregaFOB.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): AcompanhamentoEntregaFOB[] {
    let result: AcompanhamentoEntregaFOB[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: AcompanhamentoEntregaFOB[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
